module.exports = {"style":{"label":"buynow","size":"medium","shape":"rect","color":"blue"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/marketplace/paypal-config.json
// module id = 1102
// module chunks = 0